/**
 * Filter scripts.
 *
 * Handles changing the URL when a user selects a value from a filter dropdown on archive pages.
 */

/** Dependencies -------------------------------------------- */

// External

// Design system

/** The beef ------------------------------------------------ */

/**
 * Filter mixin.
 * Provides filter functionality to single element.
 */
export let mixin = ( { node = null, config = {} } = {} ) => {

    let state = {
        node,
        config,
        form: node.querySelector( 'form' ),
        select: node.querySelector( '[data-term-select]' ),
    };

    let module = {

        onSelectChange( event ) {

            event.preventDefault();

            const term = event.target.value;
            const toParams = {};

            toParams[state.select.dataset.taxQueryParam] = term === 'all' ? '' : term;

            this.setLocationByParams( toParams );            
        },

        setLocationByParams( params = {} ) {

            let archiveLink = state.node.dataset.archiveLink;
            archiveLink = archiveLink.indexOf( 'https:' ) !== -1
                ? archiveLink
                : `https:${archiveLink}`

            const toURL = new URL( archiveLink );
            const currentURL = new URL( window.location );

            const currentParams = {};
            
            for ( let [key, val] of currentURL.searchParams.entries() ) {
                currentParams[key] = val;
            }

            const newParams = Object.assign( currentParams, params );

            for( let [key, val] of Object.entries( newParams ) ) {

                if ( val ) {
                    toURL.searchParams.append( key, val );
                }
                else {
                    toURL.searchParams.delete( key );
                }
            }

            window.location = toURL
        },

        setEventBindings() {
            state.select.addEventListener( 'change', this.onSelectChange.bind( this ) )
        },

        init() {
            this.setEventBindings()
        },
    };

    return module.init()
}

/**
 * Filter module.
 * Provides an interface to apply filter functionality to all elements matching a selector.
 */
export default {

    init( { selector, config = {} } ) {

        let selected = document.querySelectorAll( selector )

        if ( ! selected.length ) return

        return Array.from( selected ).map(
            ( node, index ) => mixin( { node, config } )
        )
    }
}
